import React from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const BodyNotThingPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/nnSKrevrnbnXXW3TVYR2YC/Madeleine_Morlet_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/kadSjiD3wETHfkQoMvusFh/Madeleine_Morlet_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nJmiTHWqpCQMaetJBVisqy/Madeleine_Morlet_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9RfZp387eE89KR92dWFdwu/Madeleine_Morlet_4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6Tn1imRJUnypGS2s8QmD24/Madeleine_Morlet_5.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hto2NGTBKiXuXusdURNPh1/Madeleine_Morlet_6.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/7kgDMB5Rvokn3qjs5oRMZG/Madeleine_Morlet_7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/s4D3kYDCxaJAKbY4Bg9NFc/Madeleine_Morlet_8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/w8rwbsU6o2B7QLrSgKBUGg/Madeleine_Morlet_9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/nojS9BnP79MLUQyFsadgsu/Madeleine_Morlet_10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4A6qNmnrfKGsNRRtL9834X/Madeleine_Morlet_11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/eBnnK45zzeLXc7aHyMTkRW/Madeleine_Morlet_12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/oBY29WD1MGf1pPfkFtMU2w/Madeleine_Morlet_13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/4oBLZh6JTdtESexuYiz7BM/Madeleine_Morlet_14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/qGn8HWf1sdeLQ57UQKXDt9/Madeleine_Morlet_15.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/9ujPakBYtgxuMdN5bT849T/Madeleine_Morlet_16.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/kBaDSiZVg6EGD5fp8ZLdo5/Madeleine_Morlet_17.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/jmsmeiLfDhsjbWQgJrrVig/Madeleine_Morlet_18.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/8h5sL8nAFMjQKccsbM2L7B/Madeleine_Morlet_19.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/kjJGcmVF7v1q4RRWeBZSYZ/Madeleine_Morlet_20.jpg'];
  // Create a varied spacing array to make the layout more editorial
  const getSpacing = index => {
    const spacings = [6, 12, 8, 16, 10, 14, 7, 12, 9, 16, 10, 14];
    return spacings[index % spacings.length];
  };
  // Create a varied height array for more visual interest
  const getHeight = index => {
    const heights = ['70vh', '65vh', '75vh', '68vh'];
    return heights[index % heights.length];
  };
  const getImagePosition = (index: number) => {
    if (index === 0) return '16vh';
    const positions = ['4vh', '20vh', '8vh', '24vh', '12vh', '28vh', '16vh'];
    return positions[index % positions.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh';
    const sizes = ['80vh', '60vh', '75vh', '65vh', '85vh'];
    return sizes[index % sizes.length];
  };
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-69">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-70">
        <div className="flex space-x-6" data-id="element-71">
          <div className="text-base font-normal" data-id="element-72">
            <Link to="/" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-73">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-74">
            <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-75">
              Info
            </Link>
          </div>
        </div>
      </header>
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-76">
        <div className="flex min-w-max" data-id="element-77">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-78">
            <div className="text-base max-w-[360px] pr-4" data-id="element-79">
              <div data-id="element-80">The Body Is Not A Thing (2020 to 2024)</div>
              <div className="text-sm leading-normal mt-4" data-id="element-81">
                <em data-id="element-82">The Body Is Not A Thing</em> was conceived during lockdown.
                Like many women with young children, I experienced a loss of
                autonomy. In America, where I was living, the appetite for
                regressive politics was growing. I felt frustrated with the
                unrelatable and sanitised imagery that dominates mainstream
                representations of motherhood. In the year Roe V. Wade was
                overturned I travelled from my home, a small rural community in
                New England, to Los Angeles. I found myself drawn to the
                supposed duality of our sexual desire and our ability to give
                birth. I photographed actors, dancers, sex workers, and mothers.
                I thought I understood how to cast the female gaze. Later, as I
                reviewed the images, I found myself confronted by the enduring
                influence of the male gaze. I am forced to acknowledge the
                historical associations of female nudity, the provocation of
                shame, the influence of pornography, and internalised misogyny.
                Observing women intimately, interplaying sexuality and
                motherhood, is uncomfortable–but should it be?
              </div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-83">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-84">
                <img src={image} alt={`The Body Is Not A Thing - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-85" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-86">
        <div className="mb-6" data-id="element-87">
          <div className="text-base mb-4" data-id="element-88">
            The Body Is Not A Thing (2020 to 2024)
          </div>
          <div className="text-sm leading-normal" data-id="element-89">
            <em data-id="element-90">The Body Is Not A Thing</em> was conceived during lockdown. Like
            many women with young children, I experienced a loss of autonomy. In
            America, where I was living, the appetite for regressive politics
            was growing. I felt frustrated with the unrelatable and sanitised
            imagery that dominates mainstream representations of motherhood. In
            the year Roe V. Wade was overturned I travelled from my home, a
            small rural community in New England, to Los Angeles. I found myself
            drawn to the supposed duality of our sexual desire and our ability
            to give birth. I photographed actors, dancers, sex workers, and
            mothers. I thought I understood how to cast the female gaze. Later,
            as I reviewed the images, I found myself confronted by the enduring
            influence of the male gaze. I am forced to acknowledge the
            historical associations of female nudity, the provocation of shame,
            the influence of pornography, and internalised misogyny. Observing
            women intimately, interplaying sexuality and motherhood, is
            uncomfortable–but should it be?
          </div>
        </div>
        <div className="w-full space-y-8" data-id="element-91">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-92">
              <img src={image} alt={`The Body Is Not A Thing - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-93" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-94" />
      <style jsx data-id="element-95">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default BodyNotThingPage;